import * as Sentry from '@sentry/browser';
import { logger } from '@spotify-internal/isomorphic-logger';
import { getSilentAuthToken } from '@lib/auth/accessTokenManager/authActions';
import { AccessToken } from '@lib/auth/accessTokenManager/types';

export const defaultHeaders = {
  accept: 'application/json',
  'content-type': 'application/json',
};

export async function fetchWithToken(
  input: RequestInfo,
  init?: RequestInit,
  omitHeaders?: string[],
) {
  const req = new Request(input, init);
  let token: AccessToken | undefined;

  try {
    token = await getSilentAuthToken();
  } catch (error) {
    if ('error' in error) {
      logger.error(
        `fetchWithToken() error: ${error.error}: ${error.error_description}`,
      );
      Sentry.captureException(
        new Error(`${error.error}: ${error.error_description}`),
      );
    } else {
      // error is an Error object, capture as regular error
      logger.error(error);
      Sentry.captureException(error);
    }
  }

  const filteredDefaultHeaders = filterKeys(defaultHeaders, omitHeaders || []);

  for (const [key, value] of Object.entries(filteredDefaultHeaders)) {
    if (!req.headers.has(key)) req.headers.set(key, value);
  }

  if (token) {
    req.headers.set('authorization', `Bearer ${token}`);
  } else {
    req.headers.delete('authorization');
  }

  return fetch(req);
}

function filterKeys(
  unfiltered: { [k: string]: string },
  keysToFilter: string[],
) {
  return Object.keys(unfiltered).reduce((filtered, key) => {
    if (!keysToFilter.includes(key)) {
      filtered[key] = unfiltered[key];
    }
    return filtered;
  }, {} as { [k: string]: string });
}
